import { Alert, AlertIcon, AlertDescription, Button, HStack } from "@chakra-ui/react";
import { Link } from "react-router";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { DashboardStats } from "./models";

export default function SetUpIntegrationBanner({
  connectedIntegrations,
}: {
  connectedIntegrations: DashboardStats["connectedIntegrations"];
}) {
  const hasSetUpATS = connectedIntegrations.applicantTrackingSystem;
  const hasSetUpMessageService = connectedIntegrations.messageService;
  let title = "Connect your Slack and Applicant Tracking Systems to get started.";
  if (hasSetUpATS && !hasSetUpMessageService) {
    title = "Connect Camino with your Slack to get started.";
  } else if (!hasSetUpATS && hasSetUpMessageService) {
    title = "Connect your Applicant Tracking System to Camino.";
  }

  return (
    <Alert status="info" borderRadius="md" variant="subtle">
      <AlertIcon />
      <HStack justify="space-between" w="100%" spacing={4}>
        <AlertDescription fontSize="sm">{title}</AlertDescription>
        <Button
          as={Link}
          to={PEOPLE_TEAM_ROUTES.company.integrations.index}
          size="xs"
          colorScheme="brand"
          flexShrink={0}
        >
          Set Up Integrations
        </Button>
      </HStack>
    </Alert>
  );
}
